import { PostType } from '../enums/enums';

export class PostCreate {
  id?: number;
  eventUuid: string;
  postType: string;
  textContent: string;
  pictureUrl: string;
  authorCompany: string;
  title: string;
  showcaseId: string;
  videoLink: string;
  htmlLink: string;
  documentUrl?: string;
}

export class PostResponseObj {
  data: Post[];
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  elementsOnPage: number;
  totalElements: number;
}

export class Post {
  eventUuid: string;
  postType: PostType;
  textContent: string;
  pictureUrl: string;
  authorCompany: string;
  title: string;
  id: number;
  createdAt: Date;
  likesCount: number;
  likedByMe: boolean;
  commentsCount: number;
  userDto: PostUser;
  canDelete: boolean;
  documentUrl: string;
  videoLink: string;
  pinned: boolean;
}

export class PostUser {
  firstName: string;
  lastName: string;
  userUuid: string;
  picture: string[];
  pictureUrl: string;
  boothPin: string;
  boothName: string;
}

export class CommentCreate {
  eventUuid: string;
  postId: number;
  textContent: string;
  pictureUrl: string;
}

export class SingleComment {
  eventUuid: string;
  postId: number;
  textContent: string;
  pictureUrl: string;
  commentId: number;
  createdAt: Date;
  likesCount: number;
  userDto: PostUser;
  likedByMe: boolean;
  canDelete: boolean;
  answered: boolean;
  pinned: boolean;
}

export class CommentResponseObj {
  data: SingleComment[];
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  elementsOnPage: number;
  totalElements: number;
}

export class WallCastConfig {
  eventUuid: string = '';
  inUse: boolean = true;
  streamSortType: string = 'DATE_TIME';
  pageSizeForLikesStream: number = 1;
  timerPeriodForLikesStreamInSec: number = 10;
  pageSizeForDateTimeStream: number = 1;
  timerPeriodForDateTimeStreamInSec: number = 10;
}



// WEBPACK FOOTER //
// ./src/models/post.model.ts